export default __webpack_public_path__ + "static/media/hmh_how.380880bd.png";